import React, { useEffect, useState } from 'react';
import { Menu, X, Sun, Moon } from 'lucide-react';
import { Theme } from '../hooks/useTheme';
interface NavigationProps {
  currentPage: 'home' | 'now';
  onNavigate: (page: 'home' | 'now') => void;
  theme: Theme;
  onToggleTheme: () => void;
}
export function Navigation({
  currentPage,
  onNavigate,
  theme,
  onToggleTheme
}: NavigationProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    if (currentPage !== 'home') {
      onNavigate('home');
      setTimeout(() => {
        const element = document.getElementById(id);
        element?.scrollIntoView({
          behavior: 'smooth'
        });
      }, 100);
    } else {
      const element = document.getElementById(id);
      element?.scrollIntoView({
        behavior: 'smooth'
      });
    }
    setIsMobileMenuOpen(false);
  };
  const navLinks = [{
    name: 'About',
    id: 'about'
  }, {
    name: 'Speaking',
    id: 'speaking'
  }, {
    name: 'Contact',
    id: 'contact'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-background/80 backdrop-blur-md border-b border-border/50 py-4' : 'bg-transparent py-6'}`} data-id="element-60">
      <div className="container mx-auto px-6 flex justify-between items-center" data-id="element-61">
        <button onClick={() => onNavigate('home')} className="text-xl font-bold tracking-tighter hover:text-primary/80 transition-colors" data-id="element-62">
          MD.
        </button>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center space-x-8" data-id="element-63">
          {navLinks.map(link => <button key={link.name} onClick={() => scrollToSection(link.id)} className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors" data-id="element-64">
              {link.name}
            </button>)}
          <button onClick={() => onNavigate('now')} className={`text-sm font-medium transition-colors ${currentPage === 'now' ? 'text-foreground' : 'text-muted-foreground hover:text-foreground'}`} data-id="element-65">
            Now
          </button>

          {/* Theme Toggle */}
          <button onClick={onToggleTheme} className="p-2 rounded-lg bg-secondary/50 hover:bg-secondary transition-colors" aria-label="Toggle theme" data-id="element-66">
            {theme === 'dark' ? <Sun size={18} data-id="element-67" /> : <Moon size={18} data-id="element-68" />}
          </button>
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden flex items-center gap-3" data-id="element-69">
          <button onClick={onToggleTheme} className="p-2 rounded-lg bg-secondary/50 hover:bg-secondary transition-colors" aria-label="Toggle theme" data-id="element-70">
            {theme === 'dark' ? <Sun size={18} data-id="element-71" /> : <Moon size={18} data-id="element-72" />}
          </button>
          <button className="text-foreground" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-73">
            {isMobileMenuOpen ? <X size={24} data-id="element-74" /> : <Menu size={24} data-id="element-75" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav Overlay */}
      {isMobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-background border-b border-border p-6 md:hidden flex flex-col space-y-4 shadow-2xl" data-id="element-76">
          {navLinks.map(link => <button key={link.name} onClick={() => scrollToSection(link.id)} className="text-lg font-medium text-left text-muted-foreground hover:text-foreground" data-id="element-77">
              {link.name}
            </button>)}
          <button onClick={() => {
        onNavigate('now');
        setIsMobileMenuOpen(false);
      }} className={`text-lg font-medium text-left ${currentPage === 'now' ? 'text-foreground' : 'text-muted-foreground'}`} data-id="element-78">
            Now
          </button>
        </div>}
    </nav>;
}